// extracted by mini-css-extract-plugin
module.exports = {"switch":"SwitchButton_switch__GEDv2","slider":"SwitchButton_slider__2hIdQ","round":"SwitchButton_round__12t2B"};